/* oxlint-disable no-cycle */
import { CONNECTION_STATUS, StoreKit, consoleApi, selectActiveConnection, selectConnectionStatus } from '@nx/state';
import type * as SegmentJS from '@segment/analytics-next';

export const segmentDbCoreFieldsInjectionPlugin: SegmentJS.Plugin = {
  name: 'Connected Aura instance core fields injection',
  type: 'enrichment',
  version: '1.0.0',

  isLoaded: () => true,
  load: () => Promise.resolve(),

  track: (ctx) => {
    const state = StoreKit.UNSAFE_getGlobalStoreInstance().globalStore.getState();
    const connection = selectActiveConnection(state);
    const connectionStatus = selectConnectionStatus(state);

    if (connection?.auraId !== undefined && connectionStatus === CONNECTION_STATUS.CONNECTED) {
      ctx.updateEvent('properties.dbid', connection.auraId);
    }

    // Read instance data from Console API slice cache.
    const instance = consoleApi.endpoints.getInstance.select(connection?.auraId ?? '')(state).data;

    // Inject core fields. Add more fields here as needed.
    if (instance && connectionStatus === CONNECTION_STATUS.CONNECTED) {
      ctx.updateEvent(`properties.instance.tier`, instance.tier);
    }

    return ctx;
  },
};
